import { Link } from "react-router-dom";
import { HeaderLogo } from "../components/headerLogoComponent";
import '../../styles/login.css'
import '../../styles/register.css';
import {motion as m} from "framer-motion"
import LoginService from "../../StarterKit/Service/Bll/LoginService";
import { useNavigate } from "react-router-dom";
import React, {useContext, useState} from "react";
import CacheExtension from "../../StarterKit/Filter/CacheExtension";
import Consts from "../Consts";
import SelectLanguageComponent from "../components/SelectLanguageComponent";
import SettingService from "../../StarterKit/Service/Bll/SettingService";
import FilterService from "../Services/Bll/FilterService";
import {ViewContext} from "../Context/ViewContext";
import { Modal, Fade, Card } from '@mui/material';
import { Button } from "semantic-ui-react";
export default function LoginPage() {
    const {showLoader} = useContext(ViewContext);
    const navigate = useNavigate();
    var service = new LoginService();
    const settingService = new SettingService()

    const [openForget, setOpenForget] = useState(false);
    const [formRecover, setFormRecover] = useState(null);
    const [errors, setErrors] = useState({});
    const [regexPw, setRegexPw] = useState('');
    const [checkMailMessage, setCheckMailMessage] = useState(false);
    const [errorForget, setErrorForget] = useState(false);

    const handleCloseForget = () => {
        setOpenForget(false);
        setErrors({});
        setErrorForget(false);
    };

    const handleOpenForget = () => {
        setOpenForget(true);
    };

    var url = JSON.parse(localStorage.getItem(Consts.GROUP_HOME));
    document.getElementById('root').style.backgroundColor = 'white'
    React.useEffect(() => {
        if (sessionStorage['isLogged'] !== undefined && sessionStorage['isLogged'] === 'yes'){
            navigate(url[sessionStorage['profile']].text)
        }
        localStorage.removeItem('dates'); 
        localStorage.removeItem('zone_geo_user');
        settingService.getFromGroup('app').then(function (result) {
            let setting = result.getData()
            let regex = new RegExp(setting.passwordValidation.text)
            setRegexPw(regex)
        })
    },[])

    const handleFormRecoverChange = event => {
        if(event.target.name == "username") {
            setFormRecover({
                ...formRecover,
                [event.target.name]:event.target.value.toLowerCase()
            });
        } else {
            setFormRecover({
                ...formRecover,
                [event.target.name]:event.target.value
            });
        }
    }
    const submitRecover = async (e) => {
        e.preventDefault();
        setErrorForget(false)
        if(formRecover) {
            let res = await service.recover(formRecover);
            if(res.getCode() === 0 ) {
                setCheckMailMessage(true)
            } else {
                setErrorForget(true)
            }
        }
    };
    const  handleSubmit = async event => {
        event.preventDefault();
        const user = {
            username: document.getElementById('loginEmail').value.toLowerCase(),
            password: document.getElementById('loginPassword').value,
            service: "api"
        };
        const newErrors = {};
        if (!regexPw.test(user.password)) {
            newErrors.passwordLogin = CacheExtension.getDataFromCache("PasswordDoesntMatchPattern");
            setErrors(newErrors);
        } else {
            setErrors(newErrors);
            var result = await service.login(user);
            if (result.getCode() === 0) {
                localStorage.setItem('user_name', user.username);
                localStorage.setItem('user_password', user.password);
                localStorage.setItem('user_profile', result.data.data.profile);
                localStorage.setItem('zone_geo_user', result.data.data.zoneGeoUser);
                const filterService = new FilterService();
                try {
                    const result = await filterService.listFromModel();
                    Object.entries(result.data).forEach(([key, value]) => {
                        localStorage.setItem(key, JSON.stringify(value));
                    });
                    const storedDepartements = JSON.parse(localStorage.getItem('departements')) || [];
                    const zoneGeoUser = localStorage.getItem('zone_geo_user') || '9999';

                    if (zoneGeoUser !== 'undefined' && zoneGeoUser.trim() !== '' && (localStorage.getItem('user_profile') == 'agent' || localStorage.getItem('user_profile') == 'commercial')) {
                        const userDepartments = zoneGeoUser.split(',').map(dep => dep.trim());
                        const filteredDepartements = storedDepartements.filter(dept => userDepartments.includes(dept.value));
                        localStorage.setItem('departements', JSON.stringify(filteredDepartements));
                    }

                settingService.getFromGroup('exportField').then(result => {
                    const options = Object.entries(result.getData()).map(([key, value]) => ({
                        value: key,
                        label: value.text
                    }));
                    localStorage.setItem('exportField',  JSON.stringify(options));
                });
                } catch (error) {
                    console.error('Erreur lors de l\'appel de listFromModel:', error);
                }
                localStorage.removeItem("filteredData");
                showLoader()
                navigate('/ca')
            } else {
                alert('Identifiants incorrects')
            }
        }

    }

    return (
        <>
            <m.div initial={{ opacity : 0}} animate={{ opacity: 1}} transition={{duration: 0.50, ease: "easeOut"}} style={{overflowX:'hidden'}}>
                <div style={{backgroundColor: 'white', height: '100%'}}>
                    <div className={'titleHead container__loginpage '} id="header">
                        <HeaderLogo />
                        <h1 id="loginTitle" className="absoluteTitle">{CacheExtension.getDataFromCache("login.title")}</h1>

                    </div>

                    <div id="loginForm">
                        <form  onSubmit={handleSubmit} >
                            <input type="email" name="email" placeholder={CacheExtension.getDataFromCache("login.email")} id="loginEmail" />
                            <div id="loginPasswordContainer">
                                <input type="password" name="password" placeholder={CacheExtension.getDataFromCache("login.password")} id="loginPassword"/>
                                {/* <Link id="loginForgotten" >{CacheExtension.getDataFromCache("login.forgotten")}</Link> */}
                            </div>
                            {errors.passwordLogin && <div className="showError">{errors.passwordLogin}</div>}
                            <button id="loginButton" className="button text-center" type="submit">{CacheExtension.getDataFromCache("login.login")}</button>
                            <Link className={'button btnReverse'} onClick={handleOpenForget}>{CacheExtension.getDataFromCache("login.forgotten")}</Link>
                        </form>
                    </div>
                    {openForget && (
                        <Modal
                            open={openForget}
                            onClose={handleCloseForget}
                            closeAfterTransition
                        >
                            <Fade in={openForget}>
                                <div className="modal-container d-flex justify-content-center align-items-center"
                                     style={{height: '100vh'}}>
                                    <Card className="modal-dialog w-75"
                                          style={{maxWidth: "400px", borderRadius: '8px', margin: '20px'}}>
                                        <div className="modal-content">
                                            <div className="modal-header" style={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                height: '40px'
                                            }}>
                                                <h5 className="modal-title"
                                                    style={{marginLeft: '10px'}}>{CacheExtension.getDataFromCache('ForgottenTitle')}</h5>
                                                <div style={{marginLeft: 'auto'}}>
                                                    <Button type="button" className="close" onClick={handleCloseForget}
                                                            style={{fontSize: '15px'}}>
                                                        <span aria-hidden="true">&times;</span>
                                                    </Button>
                                                </div>
                                            </div>
                                            <form onSubmit={(e) => submitRecover(e)}>
                                                <div className="modal-body" style={{margin: '10px'}}>
                                                    <div id="confirmUser_Form">
                                                        <div id="confirmUser_Group_confirmToken_email"
                                                             className="form-inline mb-2">
                                                            <label htmlFor="confirmUser_Control_confirmToken_email"
                                                                   className="col-4 sk-auto-form sk-form-label font-weight-bold"
                                                                   style={{justifyContent: "left"}}>{CacheExtension.getDataFromCache("Email")}</label>
                                                            <input id="confirmUser_Control_confirmToken_email"
                                                                   type="email"
                                                                   className="col-8 form-control sk-auto-form sk-form-email"
                                                                   name="username" onChange={handleFormRecoverChange}/>
                                                            {errors.mails &&
                                                                <div className="showError">{errors.mails}</div>}
                                                            {errorForget && <div
                                                                className="showError">{CacheExtension.getDataFromCache("errorForget")}</div>}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className={'modal-footer'}>
                                                    <div
                                                        className={'d-flex justify-content-center align-items-center m-2'}>
                                                        <Button
                                                            disabled={checkMailMessage}
                                                        >
                                                            {CacheExtension.getDataFromCache("Validate")}
                                                        </Button>
                                                    </div>
                                                </div>
                                            </form>
                                            {checkMailMessage &&
                                                <div className="modal-body" style={{margin: '10px'}}>
                                                    <div>{CacheExtension.getDataFromCache('CheckYourMails')}</div>
                                                </div>
                                            }
                                        </div>
                                    </Card>
                                </div>
                            </Fade>
                        </Modal>
                    )}
                </div>
                </m.div>
        </>
    );
}
